import { createSelector } from '@reduxjs/toolkit';
import { selectBathroomCount } from 'shared/selectors/jsonQuery';

export const selectBathroomCountFilter = createSelector(selectBathroomCount, ({ gte }) => ({
  label: 'Два и более',
  value: !!gte && gte > 1,
}));
